// Simple deep link handler for careers page
document.addEventListener('DOMContentLoaded', function() {
    
    // Check if there's a hash in the URL
    const hash = window.location.hash;
    
    // If hash exists, handle it
    if (hash) {
        const elementId = hash.substring(1); // Remove the #
        
        // Try to find the element
        const element = document.getElementById(elementId);
        
        if (element) {
            // Find the details element inside
            const detailsElement = element?.querySelector('details');
            
            if (detailsElement) {
                // Open the details (like clicking it)
                detailsElement.setAttribute('open', '');
                
                // Scroll to the element
                element.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            } 
        } 
    }
    
    // Also handle hash changes (when user clicks links)
    window.addEventListener('hashchange', function() {  
        window.location.reload();
    });
}); 